import i18n from 'i18next';
import { produce } from 'immer';
import { REPLACE_FIELDS } from 'redux/modules/fields';
import { REPLACE_OPTIONS } from 'redux/modules/options';
import { setFailed, setSuccess } from 'redux/modules/notify';
import { updateForm as updateFormApi } from 'api/editor';

const PUBLISH_FORM = 'PUBLISH_FORM';
export const UPDATE_FORM = 'UPDATE_FORM';

export default function form(state = {}, action) {
    switch (action.type) {
        case PUBLISH_FORM: {
            return { ...state, status: 1 };
        }
        case UPDATE_FORM: {
            const { data } = action.payload;
            return { ...state, ...data };
        }
        default:
            return state;
    }
}

export function updatePublish() {
    return {
        type: PUBLISH_FORM
    };
}

export function updateForm(data) {
    return {
        type: UPDATE_FORM,
        payload: {
            data
        }
    };
}

export function saveAndUpdateFieldsAndOptions({ fields: newFields, options: newOptions }) {
    return async (dispatch, getState) => {
        const {
            flag: { formVersion },
            form: { id: formId },
            sponsor: { id: sponsorId },
            options,
            fields
        } = getState();

        const updatedFields = produce(fields, draftFields => {
            newFields.forEach(newField => {
                const updatedField = draftFields.find(f => f.id === newField.id);
                updatedField.ref = newField.ref;
            });
        });

        const updatedOptions = produce(options, draftOptions => {
            newOptions.forEach(newOption => {
                const updatedOption = draftOptions.find(o => o.id === newOption.id);
                updatedOption.ref = newOption.ref;
            });
        });

        try {
            await updateFormApi(formVersion, sponsorId, formId, {
                fields: updatedFields,
                options: updatedOptions
            });

            dispatch({ type: REPLACE_FIELDS, payload: updatedFields });
            dispatch({ type: REPLACE_OPTIONS, payload: updatedOptions });
            dispatch(setSuccess(i18n.t('form.save_success')));
        } catch (err) {
            dispatch(setFailed(i18n.t('form.save_failed')));
            throw new Error(err);
        }
    };
}
